export default __webpack_public_path__ + "static/media/Q1_3_resized.2af35ebd.jpg";